import { Dialog } from "@radix-ui/react-dialog";
import usePlaidLinkWithStatus from "@/pages/plaid/hooks/usePlaidLink";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import paymentMethodQueryKeys from "@/queries/payment-method/query-keys";

const Plaid = ({
  open,
  onClose,
  linkData,
  method_type,
  payment_method_status,
  access_token,
  accountType = "default",
  dashboard = false,
  name_on_account,
  onSuccess,
  onPlaidOpen,
  onSettled,
}) => {
  const queryClient = useQueryClient();
  const onPlaidLinkSuccess = (paymentMethod, _publicToken, _metadata) => {
    queryClient.invalidateQueries(paymentMethodQueryKeys.all);

    if (payment_method_status === "pending_manual_verification") {
      toast.success(`Your account has been successfully verified.`, {
        autoClose: 6000,
      });
    } else if (paymentMethod?.payment_method_status === "active") {
      toast.success(`Your bank account has been connected.`, {
        autoClose: 6000,
      });
    } else {
      toast.success(
        `Deposit linking has been initiated; come back in 24 hours to finish linking your account.`,
        {
          autoClose: 6000,
        }
      );
    }

    if (onSuccess) {
      onSuccess();
    }
  };

  const { linkToken, loadingToken, error, openPlaidLink, readyPlaidLink } =
    usePlaidLinkWithStatus({
      payment_method_status,
      method_type,
      access_token,
      defaultPaymentMethod: dashboard ? true : false,
      onSuccess: dashboard ? onSuccess : onPlaidLinkSuccess,
      name_on_account: name_on_account,
      onSettled,
      ...linkData,
    });

  const handleOpenPlaidLink = () => {
    openPlaidLink();

    if (onPlaidOpen) {
      onPlaidOpen();
    }
    onClose();
  };

  useEffect(() => {
    if (readyPlaidLink) {
      handleOpenPlaidLink();
    }
  }, [readyPlaidLink]);

  useEffect(() => {
    if (error) {
      toast.error("Failed to connect bank account. Please try again.");
      onClose();
    }
  }, [error]);

  return <Dialog open={open} onClose={onClose} />;
};

export default Plaid;
